import {ValidatorInterface} from './ValidatorInterface';
import {AbstractValidator, ValidatorObject} from './AbstractValidator';
import { Text } from "@/Models/Shapes/Text";

/**
 * Validator that checks if the value is equal to or lower than the set maximum amount for texts.
 */
export class MaximumTextValue extends AbstractValidator implements ValidatorInterface {
	declare instance: Text;

	/**
	 * Constructor.
	 *
	 * @param {ValidatorObject} options
	 */
	constructor( options: ValidatorObject ) {
		super( options );

		if ( this.dimension !== 'text' ) {
			throw new Error( 'The MaximumTextValue validator can only be used on the text dimension.' );
		}

		if ( ! ( this.instance instanceof Text ) ) {
			throw new Error( 'The MaximumTextValue validator can only be used on instances of Text shapes.' );
		}

		this.dimension = this.getDimension();
		const value = this.getDimensionValue();

		if ( typeof value !== 'number' ) {
			throw new Error( 'The MaximumTextValue validator can only be used on numbers.' );
		}

		this.value = value;
		this.maximum = this.maximums[ this.getDimension() ].in_cm();
	}

	getDimension(): string {
		return this.instance.getDesiredDimension();
	}

	/**
	 * @inheritDoc
	 */
	getMessage(): string {
		const { dimensions } = this.getValidatorTranslationStrings();

		return dimensions.text.sheet.max;
	}

	/**
	 * @inheritDoc
	 */
	isValid(): boolean {
		if ( typeof this.value !== 'number' ) {
			return false;
		}

		return this.value <= this.maximum;
	}
}
